import io from 'socket.io-client';
import { mapGetters } from 'vuex';
import modules from '@/modules.js';
import { getConfig } from '@/functions/general.js';
import isDev from '@/functions/isDev.js';
const dev = isDev();
const ENDPOINT_SOCKET = dev
	? 'https://socket.ac.dev.bhp.lifeon.cl'
	: 'https://socket.ac.bhp.lifeon.cl';

export default {
  data() {
    return {
      $router: this.$router,
			opened_slot:{},
			opened:false,
    };
	},
	components: { },
  computed: {
    ...mapGetters({
      menuLateral: 'menuLateral',
			menuLateralIndice: 'menuLateralIndice',
			$socket_info: '$socket_info',
		}),
    activeRouterName(){ return this.$router.currentRoute.name },
    menuActive() { return this.menuLateralIndice[this.activeRouterName] || {} },
		requestStatus() {return this.$store.getters.requestStatus},
		/* en una misma ruta podrian haber +1 de una request sincronisable */
		/* 
		las request son usadas por crud, osea que alli cuando son creados ingresar las request activas
			-considerando no repetidas
		y cuando son destruidos quitarlas
		*/
		active_requests() {return this.requestStatus.filter(f => f.active)},
		inactive_cache_requests() {return this.requestStatus.filter(f => !f.active && f.rq && f.rq.then)},
	},
	watch: { 
		'inactive_cache_requests'(inactive_cache_requests) {
			//this.dev_log({inactive_cache_requests});
		},
		'active_requests'(active_requests) {
//this.dev_log({active_requests});
		},
		'menuActive'(v) {
		// - si se recarga la pagina y esta tiene sala, esto no se gatillara
			//this.rooms.includes()
			this.dev_log('MA',v);
			if (!this.menuActive.slot_key) return;
			if (this.menuActive.slot_key) this.joinRoom(this.menuActive.slot_key);
		}
		//this.$socket.emit('joinRoom', { user_id:this.$user.id, room:'medical_center' });
	},
	created() {
		//synchro_list
	},
  methods: {
		//this.$socket.emit('synchro', {slot_key,event,data:{t:'hola'},user_id:1,slot:'medical_center'});
		joinRoom(room){
			if ([null,undefined].includes(this.menuActive)) return;
			if ([null,undefined].includes(this.$socket.emit)) return;
			if (!this.$socket_info.joined_rooms.includes(room)) {
				//no hay q cerrarlas, pq se podrian limpar lo en cache(para evitar consultar por lo mismo que la vez anterior)
				this.$socket_info.joined_rooms.push(room);
				this.dev_log({ user_id:this.user_id, room });
				this.$socket.emit('joinRoom', { user_id:this.user_id, room });
			}
			
		},
		open_slots() {
			if (this.opened) return console.error('ya se habian abierto los slots');	
			this.opened = true;
this.dev_log('openend');
			//notificaciones
			const n_slot = `n-${this.$user.id}`;
			this.$socket.emit('join', { user_id:this.user_id, slot_key: n_slot });	
			if (!this.opened_slot[n_slot]) this.$socket.on(n_slot, (res) => this.getData(n_slot,res))
			/* this.$socket.on(n_slot, (data) => {
				this.dev_log('slot',n_slot,{data});
				
			}) */
			this.opened_slot[n_slot] = true;
			//--------------------------
			
			const endpoints = [];
			const prs = [getConfig({modules,endpoints})];
			Promise.all(prs)
				.then(() => {
					endpoints
						.filter(e => e.slot_key)
						.forEach(e => {
							/* sin join, no se podrian recibir los eventos */
							if (!this.opened_slot[e.slot_key]) {
								this.$socket.emit('join', { user_id:this.user_id, slot_key: e.slot_key });	
								this.$socket.on(e.slot_key, ((key) => (res) => this.getData(key,res))(e.slot_key));
								this.opened_slot[n_slot] = true;
							}
						})
				});
		},
    resetRqStatus(rq) {
      rq.status = false;
      rq.ticking = false;
      /* rq.rq = null; */
    },
		getData(slot_key,res){
			const {method,user_id} = res;
			this.dev_log('slot>>>>>>>',slot_key,method,user_id,this.active_requests);
			this.active_requests
				.forEach(r => {
					if (r.slot_key === slot_key) {
						this.resetRqStatus(r);
						this.getRows(r);
					}
				});
			this.inactive_cache_requests
				.forEach(r => r.slot_key === slot_key && this.resetRqStatus(r));
		},
    getRows(r){
      const filters = {};
      const fls = r.filter;
      fls && Object.keys(fls).forEach(key => ![null,'',undefined].includes(fls[key]) && (filters[key] = fls[key]));
      this.requests.gets[r.name](filters);
    },
		start_socket() {
			//-/!\-deberia ser ejecutado luego de haber ingrsado las credenciales, obtenido el usuario
			const path = /* 'http://localhost:3000' // */ENDPOINT_SOCKET;
			const tk = this.$store.getters.access.val || this.$store.getters.session.access;
			this.$store.dispatch('set', { key: '$socket', val: io(
				path,
				{
					transports: ['polling'],
					query:`token=${tk}&ver=${this.is_dev?'dev':'mas'}`
				}) 
			});
			
			this.$socket.on('connect', () => {
				this.dev_log(this.$user.id);
				this.dev_log('socket connected');
				this.$socket.on('message', (data) => {
					this.dev_log('message',data.text);
				});
				this.open_slots();

				this.$socket.emit('joinRoom', { user_id:this.user_id, room:'ac_list' });

				if (this.menuActive.slot_key) this.joinRoom(this.menuActive.slot_key);
				/* this.$socket
				.on('authenticated', function () {
					//do other things
					this.dev_log('xxx');
				})
				.emit('authenticate', {token:'AAA'}); //send the jwt
        // do whatever you want with `data` */
      })	
		}
	},
};
